<template>
  <div class="queryPay page-container">
    <div class="page-title">
      {{ $t('customerService.payin_search') }}
    </div>
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.transaction_id') }}</div>
              <el-input v-model="search.transaction_id" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.merchant_order_id') }}</div>
              <el-input v-model="search.mch_order_id" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div v-if="$store.getters.isMX" class="filter-item">
              <div class="filter-item-label">{{ $t('data.pos_machine_sn') }}</div>
              <el-input v-model="search.pay_data" size="small" type="text" class="filter-item-value" clearable />
            </div>

            <!-- <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.qr_link') }}</div>
              <el-input v-model="search.qr_link" size="small" type="text" class="filter-item-value" clearable />
            </div> -->

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('customerService.payer_mobile') }}</div>
              <el-input v-model="search.payer_mobile" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item" :class="{'border-red':isShowBorderRed || isShowBorderInvoiceRed}">
              <div class="filter-item-label">
                {{ $t('merchantAccount.complete_time') }}
                <el-tooltip>
                  <div slot="content">
                    <span>{{ $t('tips.customer_manager_complete_amount_same') }}</span>
                  </div>
                  <span>

                    <i class="el-icon-warning-outline icon-warning-outline" />
                  </span>
                </el-tooltip>
              </div>
              <el-date-picker
                v-model="search.response_times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('customerService.transaction_amount') }}
                <el-tooltip>
                  <div slot="content">
                    <span>{{ $t('tips.customer_manager_complete_amount_same') }}</span>
                  </div>
                  <span>
                    <i class="el-icon-warning-outline icon-warning-outline" />
                  </span>
                </el-tooltip>
              </div>
              <el-input v-model="search.transaction_amount" :class="{'border-red':isShowBorderRed}" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t($store.getters.isMX ? 'customerService.ph_invoice_no' : 'customerService.invoice_no') }}
                <el-tooltip>
                  <div slot="content">
                    <span>{{ $t('tips.customer_manager_complete_invocice_same') }}</span>
                  </div>
                  <span>
                    <i class="el-icon-warning-outline icon-warning-outline" />
                  </span>
                </el-tooltip>
              </div>
              <el-input v-model="search.channel_reference_no" :class="{'border-red':isShowBorderInvoiceRed}" size="small" type="text" class="filter-item-value" clearable />
            </div>
            <div v-if="$store.getters.curCountry.country_code === 'RU'" class="filter-item">
              <div class="filter-item-label">
                {{ $t('customerService.paid_account_no_suffix') }}
                <el-tooltip>
                  <div slot="content">
                    <span>{{ $t('tips.customer_manager_complete_account_suffix_same') }}</span>
                  </div>
                  <span>
                    <i class="el-icon-warning-outline icon-warning-outline" />
                  </span>
                </el-tooltip>
              </div>
              <el-input v-model="search.paid_account_no_suffix" :class="{'border-red':isShowBorderAccountSuffixRed}" size="small" type="text" class="filter-item-value" clearable />
            </div>
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left" />
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn" type="primary" size="small" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.reference_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_reference_no }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isMX" :label="$t('data.pos_machine_sn')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pay_data }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchant.payment_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.transaction_status')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-status tag-custom" :type="getPayTransactionStatusStyle(scope.row.transaction_status)">{{ getPayTransactionStatusLabel(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.transaction_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_amount | toDivideWithDot }} {{ scope.row.source_currency }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isAllCountry" :label="$t('data.exchange_rate')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.source_currency === scope.row.destination_currency ? '-' : scope.row.mch_rate }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isAllCountry" :label="$t('merchantAccount.settlement_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.destination_amount | toDivideWithDot }} {{ scope.row.destination_currency }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.service_fee')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fee_split | toDivideWithDot }} {{ scope.row.fee_split_currency }}</span>
          </template>
        </el-table-column>

        <!--
        <el-table-column :label="$t('customerService.product_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.product_name || '--' }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column :label="$t('customerService.app_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.app_name }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('customerService.create_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

        <!--操作-->
        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row)" />
            </el-tooltip>
          </template>
          <!-- <template slot-scope="scope">
            <div>
              <el-popover
                v-model="scope.row.popVisible"
                placement="bottom"
                width="280"
                popper-class="refundPopover_container"
              >
                <p class="queryPay_popover_title">Refund instructions</p>
                <el-input
                  v-model="scope.row.refundTxt"
                  class="queryPay_textarea"
                  type="textarea"
                  :rows="2"
                  placeholder="Please enter the content"
                />
                <div class="queryPay_btn-container">
                  <el-button class="queryPay_size-btn" size="mini" round @click="onClickCancal(scope.$index)">{{ $t('components.cancel') }}</el-button>
                  <el-button class="queryPay_size-btn" type="primary" round @click="onClickRefundBtn(scope.$index)">{{ $t('components.submit') }}</el-button>
                </div>
                <el-button slot="reference" type="primary" size="mini" disabled>{{ $t('customerService.refund') }}</el-button>
              </el-popover>
            </div>
          </template> -->
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-container">
      <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
    </div>

    <payin-details-modal ref="paymentDetailsModal" :detail-id="detailId" />
  </div>
</template>

<script>

import { fetchMultiMchPayOrderList, fetchPayOrderList, submitRefundInstruction } from '@/api/customer-service/customer-service'
import { payTransactionStatusVoidMap, payinPaymentMethodMap } from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'
export default {
  name: 'Customer_Service_Query_Pay',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    PayinDetailsModal: () => import('./components/Modal/PayinDetailsModal')
  },
  data() {
    this.timer = null
    return {
      isShowBorderRed: false,
      isShowBorderInvoiceRed: false,
      isShowBorderAccountSuffixRed: false,
      showFilterContent: true,
      search: {
        mch_order_id: '',
        transaction_id: '',
        payment_code: '',
        payer_mobile: '',
        response_times: [],
        channel_reference_no: '',
        reference_no: '',
        paid_account_no_suffix: '',
        pay_data: ''
      },
      tableData: [],
      payTypeArr: [], // 支付类型数组
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: 0
    }
  },
  computed: {
    getPayTransactionStatusLabel() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getPayTransactionStatusStyle() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    }
  },
  created() {
  },
  methods: {
    onClickDetailBtn(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },
    getParams(otherParams = {}) {
      const { response_times = [], transaction_amount, ...otherSearch } = this.search

      let params = {
        response_start_date_time: response_times && response_times[0],
        response_end_date_time: response_times && response_times[1],
        ...otherSearch,
        ...otherParams
      }
      if (transaction_amount || transaction_amount === 0) {
        params.transaction_amount = this.$commonFn.mathMultiply(Number(transaction_amount), 100)
      }
      params = filterEmptyAttr(params)
      return params
    },
    handleFilter(params = {}) {
      const newParam = this.getParams(params)
      this.getPayOrderList(newParam)
    },
    confirm() {
      const params = {
        page: this.listQuery.page
      }
      this.handleFilter(params)
    },
    showPayDetailModal() {
      this.$refs.paymentDetailsModal.changModalStatus(true)
    },
    onClickCancal(index) {
      this.tableData[index].refundTxt = ''
      this.tableData[index].popVisible = false
    },
    onClickRefundBtn(index) {
      // 请求接口
      submitRefundInstruction().then((res) => {
        if (res.code === 10000) {
          this.tableData[index].refundTxt = ''
          this.tableData[index].popVisible = false
        }
      }).catch((err) => {
        console.error('eee', err)
        this.tableData[index].refundTxt = ''
        this.tableData[index].popVisible = false
      })
    },
    onClickSearchBtn() {
      const { mch_order_id, transaction_id, payment_code, payer_mobile, qr_link, reference_no, transaction_amount, response_times, channel_reference_no, paid_account_no_suffix } = this.search

      const [response_start_date] = response_times || []

      if ((!transaction_amount && response_start_date && !channel_reference_no && !reference_no && !paid_account_no_suffix)) {
        this.$message({ type: 'warning', showClose: true, duration: 5000, message: 'Please enter the Amount or the QRPH Invoice No. with the Complete Time ' })

        this.isShowBorderRed = true
        this.isShowBorderInvoiceRed = true
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.isShowBorderRed = false
          this.isShowBorderInvoiceRed = false
        }, 5000)
        return
      }

      if ((transaction_amount && (!response_start_date))) {
        this.$message({ type: 'warning', showClose: true, duration: 5000, message: 'Please enter both the Amount and the Complete Time' })

        this.isShowBorderRed = true
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.isShowBorderRed = false
        }, 5000)
        return
      }

      if ((channel_reference_no && (!response_start_date))) {
        this.$message({ type: 'warning', showClose: true, duration: 5000, message: 'Please enter both the QRPH Invoice No. and the Complete Time' })

        this.isShowBorderInvoiceRed = true
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.isShowBorderInvoiceRed = false
        }, 5000)
        return
      }

      if ((paid_account_no_suffix && (!response_start_date))) {
        this.$message({ type: 'warning', showClose: true, duration: 5000, message: 'Please enter both the Paid Account No Suffix and the Complete Time' })

        this.isShowBorderAccountSuffixRed = true
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.isShowBorderAccountSuffixRed = false
        }, 5000)
        return
      }

      if (!transaction_amount && !response_start_date) {
        if (!mch_order_id && !transaction_id && !payment_code && !payer_mobile && !qr_link && !reference_no && !channel_reference_no) {
          this.$message({ type: 'warning', showClose: true, duration: 5000, message: 'At least one parameter' })
          return
        }
      }

      this.handleFilter()
    },
    // 获取请求列表
    getPayOrderList(params = {}) {
      this.listLoading = true
      const fetchPayOrderListApi = this.$store.getters.isAllCountry
        ? fetchMultiMchPayOrderList
        : fetchPayOrderList
      fetchPayOrderListApi(params).then(res => {
        this.tableData = res.data.list
        this.listQuery.total = res.data.total
        this.listQuery.page = params.page ? params.page : 1
      }).finally(() => {
        this.listLoading = false
        this.isShowBorderRed = false
      })
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-warning-outline{
  position: relative;
  top: 2px;
  color:  #4B5567;
  font-size: 16px;
}
.queryPay_popover_title{
  text-align: center;
  color: #606266;
}
.queryPay_textarea{
  margin-bottom: 20px;
}
.queryPay_btn-container{
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
}
.queryPay_size-btn{
  width: 80px;
  height: 28px;
  line-height: 6px;
}
.queryPay{
  margin: 20px;
  background: #fff;
  border-radius: 4px;
  .pagination-container{
      padding: 20px;
      margin-top: 0;
  }
  .filter-container{
    padding: 40px 0 24px 24px;
  }

   .search-frame {
    width: 256px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
  // .search-btn {
  //   margin-left: 10px;
  // }
  .tag-status{
    // text-decoration: underline;
    // cursor: pointer;
  }
}

</style>
